module.exports = __webpack_public_path__ + "media/img/illustrations/icons/filter-shifts-2fe25b31bd9810af68329f69024843b9.svg";